import React from 'react';
interface EyebrowProps {
  children: React.ReactNode;
  tone?: 'brass' | 'muted';
}
export function Eyebrow({
  children,
  tone = 'brass'
}: EyebrowProps) {
  return <p className={`text-[11px] font-semibold uppercase tracking-label ${tone === 'brass' ? 'text-brass-dark' : 'text-ink-muted'}`} data-id="element-72" data-mp="1pou3oxc0sg83">
      {children}
    </p>;
}